import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Actions as ACTIONS } from "../../store/actions/gradeActions";
import { CheckBadgeIcon } from "@heroicons/react/20/solid";
import CreatableSelect from "react-select/creatable";
import { v4 as uuidv4 } from "uuid";
import Modal from "@/common/Modal";
import SalaryDetails from "../employees/salary-details/SalaryDetails";
import { NotificationManager } from "react-notifications";

const GradeModal = ({ modalState, modalGrade, gradeSetOpenModal, gradeSave, disabled }) => {
	const [salaryData, setSalaryData] = useState({});
	const [data, setData] = useState({});

	//Reset Grade Data on Modal Open
	useEffect(() => {
		if (!modalState) return;

		setSalaryData({ ...modalGrade?.salary });
		setData({ ...modalGrade });
	}, [modalGrade && modalGrade.id, modalState]);

	const saveGradeData = () => {
		const gradeData = {
			...modalGrade,
			...data,
			id: (modalGrade && modalGrade.id) || uuidv4(),
			salary: salaryData,
		};

		if (!data?.name || !salaryData.salaryAmount || !salaryData?.salaryPeriod || !salaryData?.employmentType)
			return NotificationManager.error(
				`${
					(!data?.name && "Name") ||
					(!salaryData?.salaryAmount && "Salary") ||
					(!salaryData?.salaryPeriod && "Period") ||
					(!salaryData?.employmentType && "Employment Type")
				} field must be filled in!`,
				"Grade Modal",
			);

		gradeSave(gradeData);
	};

	return (
		<Modal
			status={modalState}
			close={() => gradeSetOpenModal(false, null)}
			width="75%"
			title={`${modalGrade ? "Edit" : "Add"} Grade`}
		>
			<div className="block-content max-h-[calc(95vh-105px-60px)] overflow-y-auto">
				<div className="col-xs-12 form-section mt-0">
					<div className="col-xs-12 p-0 mb-8">
						<div className="col-xs-12 pull-left mb-10">
							<h1 className="block-title">Grade</h1>
						</div>
						<div className="col-xs-4 mb-5">
							<div
								className="form-material"
								style={{ position: "relative" }}
							>
								<label>Name*</label>
								<input
									className="form-control form-input"
									id="salaryAmount"
									name="salaryAmount"
									disabled={disabled}
									value={data?.name || ""}
									onChange={(e) => {
										const newData = { ...data };
										newData.name = e.target.value;
										setData(newData);
									}}
									autoComplete="off"
								/>
							</div>
						</div>
						<div className="col-xs-12">
							<label className="m-1">Specify Allowed Roles</label>
							<CreatableSelect
								isMulti
								isClearable
								placeholder="Type allowed roles..."
								value={data?.roles?.map((role) => ({ label: role, value: role })) || null}
								onChange={(e) => {
									const newData = { ...data };
									newData.roles = [...e.map((role) => role.value)];
									setData(newData);
								}}
							/>
							<span className="help-block">
								Type in role names to define allowed roles for this grade
							</span>
						</div>
					</div>
				</div>
				<SalaryDetails
					location="gradeModal"
					data={salaryData}
					setData={setSalaryData}
					disabled={disabled}
				/>
			</div>
			<div
				className="col-xs-12 pb-2 pt-2 bg-white"
				style={{
					position: "sticky",
					bottom: 0,
					width: "100%",
					zIndex: 50,
					borderRadius: 11,
					marginBottom: -1,
				}}
			>
				<button
					className="btn btn-success pull-right"
					onClick={() => saveGradeData()}
				>
					<CheckBadgeIcon style={{ height: "1.5em", float: "left", marginRight: 5 }} />
					<span style={{ float: "left" }}>Save</span>
				</button>
				<button
					className="btn btn-danger pull-right mr-2"
					onClick={() => gradeSetOpenModal(false, null)}
				>
					<span>Cancel</span>
				</button>
			</div>
		</Modal>
	);
};

const mapStateToProps = (state) => {
	return {
		disabled: state?.permissions?.my?.permissions?.grades == "Read",
		...state.grades,
		jurisdiction: state.company?.settings?.jurisdiction,
		allowanceList: [...(state.allowances?.allowanceList || []), ...(state?.company?.settings?.allowances || [])],
		overtimeList: state?.company?.settings?.overtimes,
	};
};

const mapDispatchToProps = (dispatch) => ({
	gradeSetOpenModal: (status, grade) => dispatch(ACTIONS.gradeSetOpenModal(status, grade)),
	gradeSave: (grade) => dispatch(ACTIONS.gradeSave(grade)),
});

export default connect(mapStateToProps, mapDispatchToProps)(GradeModal);
